<list-view [liste]="geographieService.listeRegions" *ngIf="geographieService.listeRegions"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>